import { render, staticRenderFns } from "./MarketingCampaignsBreakdownTable.vue?vue&type=template&id=47ba72f3&scoped=true&"
import script from "./MarketingCampaignsBreakdownTable.vue?vue&type=script&lang=js&"
export * from "./MarketingCampaignsBreakdownTable.vue?vue&type=script&lang=js&"
import style0 from "./MarketingCampaignsBreakdownTable.vue?vue&type=style&index=0&id=47ba72f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ba72f3",
  null
  
)

export default component.exports